import { faSpinner } from "@fortawesome/pro-duotone-svg-icons";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";
export var maintenanceStatusConfig = {
    2: { colorClass: "blue-5", icon: faSpinner },
    3: { colorClass: "green", icon: faCheckCircle },
    6: { colorClass: "pink", icon: faExclamationCircle }
};
export var incidentStatusConfig = {
    2: { colorClass: "blue-5", icon: faSpinner },
    4: { colorClass: "green", icon: faCheckCircle },
    5: { colorClass: "pink", icon: faExclamationCircle }
};
export var sitesStatusConfig = {
    1: { colorClass: "blue-5", icon: faSpinner },
    4: { colorClass: "green", icon: faCheckCircle },
    2: { colorClass: "pink", icon: faExclamationCircle }
};
//# sourceMappingURL=notifications.js.map